import { Root, UnityAppPageLoading } from '@/ux'
import { lazy, Suspense } from 'react'
import { createBrowserRouter, createRoutesFromElements, Navigate, Route } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import { PageLayoutProvider } from './catalog-apps/components/AppPage2/useAppPageLayout'
import { AppPageLayout, CatalogLayout } from './layouts/CatalogLayout'
import { MainLayout } from './layouts/MainLayout'
import { ManagementPageLayout } from './layouts/ManagementPageLayout'
import { ProtectedRoutes } from './layouts/ProtectedRoutes'
import { SubscriptionsRootLayout } from './layouts/SubscriptionsRootLayout'
import { WorkspacesRootLayout } from './layouts/WorkspacesRootLayout'
import { ApplicationsRootLayout } from './pages/Applications'
import { AppAccessesPage } from './pages/Applications/AppAccessesPage/AppAccessesPage'
import { AppDatabricksPage } from './pages/Applications/AppDatabricksPage'
import { AppDetailsPage } from './pages/Applications/AppDetailsPage'
import { ApplicationNavMenu } from './pages/Applications/ApplicationNavMenu'
import { ApplicationsHome } from './pages/Applications/ApplicationsHome'
import { MenuBuilderPage } from './pages/Applications/AppMenuBuilderPage'
import { AppPagesPage } from './pages/Applications/AppPagesPage'
import { AppPermissionsPageV2 } from './pages/Applications/AppPermissionsPageV2/AppPermissionsPageV2'
import { AppRolesPage } from './pages/Applications/AppRolesPage'
import { AppSettingsPage } from './pages/Applications/AppSettingsPage'
import { AppContainerLogsPage } from './pages/Applications/AppContainerLogsPage/AppContainerLogsPage'
import { AppDetailsPreview, AppEditAttributes, AppsMarketingPage } from './pages/Applications/AppsMarketingPage'
import { AppTeamsPage } from './pages/Applications/AppTeamsPage/AppTeamsPage'
import { AppPageBuilderPage } from './pages/Applications/AppPageBuilderPage'
import { ApplicationFileManagerPage } from './pages/Applications/ApplicationFileManagerPage/ApplicationFileManagerPage'
import { ChatTestPage } from './pages/ChatTest/ChatTest'
import { FeaturedApps, FeaturedAppsContent } from './pages/FeaturedApps/FeaturedApps'
import { FeaturedAppDetails } from './pages/FeaturedApps/FetauredAppDetails/FeaturedAppDetails'
import { HomePage } from './pages/Homepage/Homepage'
import { HomePageContent } from './pages/Homepage/HomepageContent'
import { HomePageV2 } from './pages/HomePageV2/HomePageV2'
import { OrganisationDetailsPage } from './pages/Subscriptions/OrganisationDetailsPage/OrganisationDetailsPage'
import { OrganisationProjectsPage } from './pages/Subscriptions/OrganisationProjectsPage'
import { OrganisationTeamsPage } from './pages/Subscriptions/OrganisationTeamsPage'
import { OrganisationUsersPage } from './pages/Subscriptions/OrganisationUsersPage'
import { OrganisationAiGatewaysPage } from './pages/Subscriptions/OrganisationAiGatewaysPage'
import { OrganisationTokenLimitsPage } from './pages/Subscriptions/OrganisationTokenLimitsPage'
import { OrganisationWorkspacesPage } from './pages/Subscriptions/OrganisationWorkspacesPage'
import { OrganisationRequestsPage } from './pages/Subscriptions/OrganisationRequestsPage'
import { SubscriptionNavMenu } from './pages/Subscriptions/SubscriptionNavMenu'
import { SubscriptionsHome } from './pages/Subscriptions/SubscriptionsHome/SubscriptionsHome'
import { WorkspaceFilesPage } from './pages/Workspaces/WorkspaceFilesPage'
// import { WorkspaceDagsterPage } from './pages/Workspaces/WorkspaceDagsterPage'
import { WorkspaceDatabricksPage } from './pages/Workspaces/WorkspaceDatabricksPage'
import { WorkspaceDetailsPage } from './pages/Workspaces/WorkspaceDetailsPage'
import { WorkspaceEntitiesPage } from './pages/Workspaces/WorkspaceEntitiesPage'
import { WorkspacesNavMenu } from './pages/Workspaces/WorkspaceNavMenu'
import { WorkspaceSettingsPage } from './pages/Workspaces/WorkspaceSettingsPage/WorkspaceSettingsPage'
import { WorkspacesHome } from './pages/Workspaces/WorkspacesHome/WorkspacesHome'
import { Providers } from './Providers'
// import { ImageControl } from './ui-legacy/ImageControl/ImageControl'
// import { PlatformControl } from './ui-legacy/PlatformControl/PlatformControl'
import { LoginPage } from './ux/LoginPage'
import { PlatformNavMenu } from './pages/Platform/PlatformNavMenu'
import { PlatformHomePage } from './pages/Platform/PlatformHomePage'
import { PlatformHealthStatusPage } from './pages/Platform/PlatformHealthStatusPage'
import { PlatformUsersPage } from './pages/Platform/PlatformUsersPage'
import { PlatformImagesPage } from './pages/Platform/PlatformImagesPage'
import { PlatformContainersPage } from './pages/Platform/PlatformContainersPage'
import { PlatformDatabricksPage } from './pages/Platform/PlatformDatabricksPage'
import { PlatformDagsterPage } from './pages/Platform/PlatformDagsterPage'
import { DagsterApplicationsPage } from './pages/Platform/PlatformDagsterPage/DagsterApplicationsPage'
import { DagsterApplicationRunsPage } from './pages/Platform/PlatformDagsterPage/DagsterApplicationRunsPage'
import { AppDagsterPage } from './pages/Applications/AppDagsterPage'
import { WorkspaceDagsterPageV2 } from './pages/Workspaces/WorkspaceDagsterPageV2'
import { AppSyncPageV3 } from './pages/Applications/AppSyncPageV3/AppSyncPageV3'
import { PlatformAuditLogsPage } from './pages/Platform/PlatformAuditLogsPage'
import { PlatformFailedLoginsPage } from './pages/Platform/PlatformFailedLoginsPage'
import { PlatformLlmProvidersPage } from './pages/Platform/PlatformProvidersPage/PlatFormLlmProvidersPage'
import { PlatformAgentToolsPage } from './pages/Platform/PlatformAgentToolsPage'
import { PlatformAgentSkillsPage } from './pages/Platform/PlatformAgentSkillsPage'
import { ProjectAgentSkillsPage } from './pages/Projects/ProjectAgentSkillsPage'
import { PlatformTicketRequestsPage } from './pages/Platform/PlatformTicketRequestsPage'
import { PlatformDesignSystemPage } from './pages/Platform/PlatformDesignSystemPage/PlatformDesignSystemPage'
import { WorkspaceDataTemplatesPage } from './pages/Workspaces/WorkspaceDataTemplatesPage/WorkspaceDataTemplatesPage'
import { WorkspaceDataAssetsPage } from './pages/Workspaces/WorkspaceDataAssetsPage/WorkspaceDataAssetsPage'
import { WorkspaceFileManagerPage } from './pages/Workspaces/WorkspaceFileManagerPage/WorkspaceFileManagerPage'
import { AppFaqPage } from './pages/Applications/AppFaqPage/AppFaqPage'
import { AppGlossaryPage } from './pages/Applications/AppGlossaryPage/AppGlossaryPage'
import { AppTermsPage } from './pages/Applications/AppTermsPage/AppTermsPage'
import { AppPrivacyPolicyPage } from './pages/Applications/AppPrivacyPolicyPage/AppPrivacyPolicyPage'
import { WorkspaceEventSchedulerPage } from './pages/Workspaces/WorkspaceEventSchedulerPage/WorkspaceEventSchedulerPage'
import { DocsSlugRouter } from './pages/Docs/DocsSlugRouter'
import { DocsNavMenu } from './pages/Docs/DocsNavMenu'
import { UnityAppCatchAll } from './pages/Docs/UnityAppCatchAll'
import { ProjectsRootLayout } from './layouts/ProjectsRootLayout'
import { DmpChatPage } from './pages/Projects/DmpChatPage/DmpChatPage'
import { ProjectOverviewPage } from './pages/Projects/ProjectOverviewPage'
import { ProjectDatabricksIntegrationPage } from './pages/Projects/ProjectDatabricksPage/ProjectDatabricksIntegrationPage'
import { ProjectDatabricksNotebooksPage } from './pages/Projects/ProjectDatabricksPage/ProjectDatabricksNotebooksPage'
import { ProjectFileManagerPage } from './pages/Projects/ProjectFileManagerPage/ProjectFileManagerPage'
import { ProjectsHome } from './pages/Projects/ProjectsHome/ProjectsHome'
import { ProjectsNavMenu } from './pages/Projects/ProjectsNavMenu'
import { AgentStudioAgentPage } from './pages/AgentStudio/AgentStudioAgentPage/AgentStudioAgentPage'
import { AgentStudioAgentsPage } from './pages/AgentStudio/AgentStudioAgentsPage/AgentStudioAgentsPage'
import { AgentStudioNewAgentPage } from './pages/AgentStudio/AgentStudioNewAgentPage/AgentStudioNewAgentPage'
import { AgentStudioSchedulesPage } from './pages/AgentStudio/AgentStudioSchedulesPage/AgentStudioSchedulesPage'
import { AgentStudioSkillsPage } from './pages/AgentStudio/AgentStudionSkillsPage/AgentStudionSkillsPage'
import { AgentStudioNavMenu } from './pages/AgentStudio/AgentStudioNavMenu'
import { AgentStudioHomePage } from './pages/AgentStudio/AgentStudioHomePage'
const AppPage2 = lazy(() => import('./catalog-apps/components/AppPage2/AppPage2'))
const MdTextViewerPage = lazy(() =>
  import('./catalog-apps/components/component-library/MdTextComponent/MdTextViewerPage').then((m) => ({
    default: m.MdTextViewerPage,
  }))
)
const UnityApp = lazy(() => import('./ux/App/UnityApp'))
const EmbeddedAppLayout = lazy(() =>
  import('./layouts/EmbeddedAppLayout/EmbeddedAppLayout').then((m) => ({ default: m.EmbeddedAppLayout }))
)
const EmbeddedAppHost = lazy(() =>
  import('./embedded-apps/EmbeddedAppHost').then((m) => ({ default: m.EmbeddedAppHost }))
)

const App = () => {
  return (
    <Providers>
      <Router />
    </Providers>
  )
}

const Router = () => {
  return <RouterProvider router={router} />
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Root />}>
      <Route element={<MainLayout />}>
        {/* <Route index element={<LandingLoggedOut />} /> */}
        <Route element={<HomePage />}>
          <Route index element={<HomePageV2 />} />
          <Route path="home-v2" element={<HomePageContent />} />
          <Route path="featured-apps" element={<FeaturedApps />}>
            <Route index element={<FeaturedAppsContent />} />
            <Route path=":appId" element={<FeaturedAppDetails />} />
          </Route>
        </Route>
        <Route path="oauth" element={<LoginPage />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="docs/*" element={<ManagementPageLayout menu={<DocsNavMenu />} content={<DocsSlugRouter />} />} />

          <Route path="projects" element={<ProjectsRootLayout />}>
            <Route index element={<ProjectsHome />} />
            <Route path=":projectId" element={<ManagementPageLayout menu={<ProjectsNavMenu />} />}>
              <Route index element={<ProjectOverviewPage />} />
              <Route path="chat" element={<DmpChatPage />} />
              <Route path="agent-skills" element={<ProjectAgentSkillsPage />} />
              <Route path="databricks" element={<ProjectDatabricksIntegrationPage />} />
              <Route path="databricks/notebooks" element={<ProjectDatabricksNotebooksPage />} />
              <Route path="file-manager" element={<ProjectFileManagerPage />} />
            </Route>
          </Route>

          <Route path="workspaces" element={<WorkspacesRootLayout />}>
            <Route index element={<WorkspacesHome />} />
            <Route path=":workspaceId" element={<ManagementPageLayout menu={<WorkspacesNavMenu />} />}>
              <Route index element={<WorkspaceDetailsPage />} />
              <Route path="entities" element={<WorkspaceEntitiesPage />} />
              <Route path="files" element={<WorkspaceFilesPage />} />
              <Route path="file-manager" element={<WorkspaceFileManagerPage />} />
              <Route path="file-templates" element={<WorkspaceDataTemplatesPage />} />
              <Route path="data-assets" element={<WorkspaceDataAssetsPage />} />
              <Route path="settings" element={<WorkspaceSettingsPage />} />
              <Route path="databricks" element={<WorkspaceDatabricksPage />} />
              <Route path="dagster" element={<WorkspaceDagsterPageV2 />} />
              <Route path="event-scheduler" element={<WorkspaceEventSchedulerPage />} />
            </Route>
          </Route>

          <Route path="applications" element={<ApplicationsRootLayout />}>
            <Route index element={<ApplicationsHome />} />
            <Route
              path=":appKey"
              element={
                <PageLayoutProvider>
                  <ManagementPageLayout menu={<ApplicationNavMenu />} />
                </PageLayoutProvider>
              }
            >
              <Route index element={<AppDetailsPage />} />
              <Route path="menu" element={<MenuBuilderPage />} />
              <Route path="roles" element={<AppRolesPage />} />
              {/* <Route path="perms" element={<AppPermissionsPage />} /> */}
              <Route path="perms" element={<AppPermissionsPageV2 />} />
              <Route path="accesses" element={<AppAccessesPage />} />
              <Route path="teams" element={<AppTeamsPage />} />
              <Route path="pages" element={<AppPagesPage />} />
              <Route path="marketing" element={<AppsMarketingPage />}>
                <Route index element={<AppDetailsPreview />} />
                <Route path="edit-attributes" element={<AppEditAttributes />} />
              </Route>
              <Route path="sync" element={<AppSyncPageV3 />} />
              <Route path="dagster" element={<AppDagsterPage />} />
              <Route path="databricks" element={<AppDatabricksPage />} />
              <Route path="settings" element={<AppSettingsPage />} />
              <Route path="container-logs" element={<AppContainerLogsPage />} />
              <Route path="page-builder" element={<AppPageBuilderPage />} />
              <Route path="file-manager" element={<ApplicationFileManagerPage />} />
              <Route path="faq" element={<AppFaqPage />} />
              <Route path="glossary" element={<AppGlossaryPage />} />
              <Route path="terms" element={<AppTermsPage />} />
              <Route path="privacy-policy" element={<AppPrivacyPolicyPage />} />
            </Route>
          </Route>

          <Route path="subscriptions" element={<SubscriptionsRootLayout />}>
            <Route index element={<SubscriptionsHome />} />
            <Route path="requests" element={<Navigate to="/platform/requests" replace />} />
            <Route path=":organisationId" element={<ManagementPageLayout menu={<SubscriptionNavMenu />} />}>
              <Route index element={<OrganisationDetailsPage />} />
              <Route path="users" element={<OrganisationUsersPage />} />
              <Route path="projects" element={<OrganisationProjectsPage />} />
              <Route path="teams" element={<OrganisationTeamsPage />} />
              <Route path="workspaces" element={<OrganisationWorkspacesPage />} />
              <Route path="ai-gateways" element={<OrganisationAiGatewaysPage />} />
              <Route path="token-limits" element={<OrganisationTokenLimitsPage />} />
              <Route path="requests" element={<OrganisationRequestsPage />} />
            </Route>
          </Route>

          <Route path="platform" element={<ManagementPageLayout menu={<PlatformNavMenu />} />}>
            <Route index element={<PlatformHomePage />} />
            <Route path="health-status" element={<PlatformHealthStatusPage />} />
            <Route path="users" element={<PlatformUsersPage />} />
            <Route path="requests" element={<PlatformTicketRequestsPage />} />
            <Route path="images" element={<PlatformImagesPage />} />
            <Route path="containers" element={<PlatformContainersPage />} />
            <Route path="databricks" element={<PlatformDatabricksPage />} />
            <Route path="dagster" element={<PlatformDagsterPage />}>
              <Route index element={<DagsterApplicationsPage />} />
              <Route path=":applicationId" element={<DagsterApplicationRunsPage />} />
            </Route>
            <Route path="audit-logs" element={<PlatformAuditLogsPage />} />
            <Route path="failed-logins" element={<PlatformFailedLoginsPage />} />
            <Route path="llm-providers" element={<PlatformLlmProvidersPage />} />
            <Route path="agent-tools" element={<PlatformAgentToolsPage />} />
            <Route path="agent-skills" element={<PlatformAgentSkillsPage />} />
            <Route path="design-system" element={<PlatformDesignSystemPage />} />
          </Route>

          <Route path="agent-studio" element={<ManagementPageLayout menu={<AgentStudioNavMenu />} />}>
            <Route index element={<AgentStudioHomePage />} />
            <Route path="agents" element={<AgentStudioAgentsPage />} />
            <Route path="agents/new" element={<AgentStudioNewAgentPage />} />
            <Route path="agents/:agentId" element={<AgentStudioAgentPage />} />
            <Route path="skills" element={<AgentStudioSkillsPage />}></Route>
            <Route path="schedules" element={<AgentStudioSchedulesPage />} />
          </Route>

          <Route path="chat-test" element={<ChatTestPage />} />
          {/* Embedded React apps */}
          <Route
            path="embedded"
            element={
              <Suspense fallback={<UnityAppPageLoading />}>
                <EmbeddedAppLayout />
              </Suspense>
            }
          >
            <Route
              path=":appKey/*"
              element={
                <Suspense fallback={<UnityAppPageLoading />}>
                  <EmbeddedAppHost />
                </Suspense>
              }
            />
          </Route>
          {/* Components Catalog Apps */}
          <Route path="apps" element={<CatalogLayout />}>
            <Route path=":appKey" element={<AppPageLayout />}>
              <Route
                path="md-text-viewer/*"
                element={
                  <Suspense fallback={<UnityAppPageLoading />}>
                    <MdTextViewerPage />
                  </Suspense>
                }
              />
              <Route path=":page/*" element={<AppPage2 />} />
            </Route>
          </Route>
          {/* Unity Apps */}
          <Route path=":appKey/:page?" element={<UnityAppCatchAll />}>
            <Route
              index
              element={
                <Suspense fallback={<UnityAppPageLoading />}>
                  <UnityApp />
                </Suspense>
              }
            />
            <Route
              path="*"
              element={
                <Suspense fallback={<UnityAppPageLoading />}>
                  <UnityApp />
                </Suspense>
              }
            />
          </Route>
        </Route>
      </Route>
    </Route>
  )
)

export default App
